import { render, staticRenderFns } from "./NbSort.vue?vue&type=template&id=1069fb94"
import script from "./NbSort.vue?vue&type=script&lang=js"
export * from "./NbSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports